<template>
  <router-link
    :to="{ path: `/${toolItem.slug}` }"
    class="shadow-lg bg-slate-100 rounded-lg p-2 lg:p-4 flex space-x-4 hover:bg-cyan-100 transition"
  >
    <div class="min-w-[20%] w-1/5">
      <ToolIcon :slug="toolItem.slug" class="w-full" />
    </div>
    <div class="flex-grow flex flex-col space-y-2">
      <h3 class="font-bold text-xl">{{ toolItem.name }}</h3>
      <p class="text-gray-600">{{ toolItem.description }}</p>
    </div>
  </router-link>
</template>

<script setup lang="ts">
  import ToolIcon from '&/ToolIcon.vue'

  defineProps<{
    toolItem: object
  }>()
</script>
